import { DocumentReaderRunState } from './types';

/** A run in one of these states never changes again. */
export const DOCUMENT_READER_FINISHED_RUN_STATES: readonly DocumentReaderRunState[] =
  [
    DocumentReaderRunState.COMPLETED,
    DocumentReaderRunState.STOPPED,
    DocumentReaderRunState.FAILED,
  ];
